import { createFileRoute } from '@tanstack/react-router';
import { AuthCard, AuthShell } from '@/features/auth/layout/auth-layout';
import {
  AcceptInvitationForm,
  InvitationLinkDeadPanel,
} from '@/features/auth/forms/accept-invitation-form';
import { sanitizeToken } from '@/features/auth/validators/token-search';

// FR-03 : route PUBLIQUE — la personne invitée n'a pas encore de compte.
export const Route = createFileRoute('/invitation/$token')({
  component: AcceptInvitationPage,
});

function AcceptInvitationPage() {
  const { token } = Route.useParams();
  // Lien tronqué ou forgé : détecté sans appel API, même écran que le refus.
  const validToken = sanitizeToken(token);

  return (
    <AuthShell brandPane>
      <AuthCard title={validToken ? 'Rejoindre votre entreprise' : undefined}>
        {validToken ? (
          <AcceptInvitationForm token={validToken} />
        ) : (
          <InvitationLinkDeadPanel />
        )}
      </AuthCard>
    </AuthShell>
  );
}
